import { DengueRelatoryInteractor, DengueRelatoryRequest, DengueRelatoryStructRequest } from "../../Coordinator/DengueRelatory/DengueRelatoryInteractor";

export class DengueRelatoryViewModel {
	private interactor: DengueRelatoryInteractor;

	constructor() {
		this.interactor = new DengueRelatoryInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new DengueRelatoryRequest(
			obj["sgepdengue"] ? parseInt(obj["sgepdengue"]) : 0,
			obj["nome"] ? obj["nome"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new DengueRelatoryStructRequest(obj["sgepdengue"] ? parseInt(obj["sgepdengue"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}


	public assinarPdf(sgepdengue: number): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.assinarPdf(sgepdengue).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
	public baixarPDFFrente(sgepdengue: number): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.baixarPDFFrente(sgepdengue).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
	public baixarPDFVerso(sgepdengue: number): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.baixarPDFVerso(sgepdengue).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
	public baixarPDFResumoSemanalSUS(sgepdengue: number): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.baixarPDFResumoSemanalSUS(sgepdengue).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
	public baixarPDFAmostraColetada(sgepdengue: number): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.baixarPDFAmostraColetada(sgepdengue).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
	public baixarXLSXAmostraColetada(sgepdengue: number): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.baixarXLSXAmostraColetada(sgepdengue).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}